/** Air-raid alerts API client (web) — per-location config, status, history, regions. */
import { apiClient } from '../../../services/apiClient';
import type {
  AlertHistoryPageDto,
  AlertStatusDto,
  LocationAlertConfigDto,
  SaveAlertConfigRequest,
  UkraineRegionDto,
} from '../types';

const loc = (locationId: string) => `/api/v1/organizations/me/locations/${locationId}`;

export const getAlertConfig = (locationId: string) =>
  apiClient.get<LocationAlertConfigDto>(`${loc(locationId)}/alert-config`);

export const saveAlertConfig = (locationId: string, request: SaveAlertConfigRequest) =>
  apiClient.put<LocationAlertConfigDto>(`${loc(locationId)}/alert-config`, request);

export const enableAlertConfig = (locationId: string) =>
  apiClient.post<void>(`${loc(locationId)}/alert-config/enable`);

export const disableAlertConfig = (locationId: string) =>
  apiClient.post<void>(`${loc(locationId)}/alert-config/disable`);

export const getAlertStatus = (locationId: string) =>
  apiClient.get<AlertStatusDto>(`${loc(locationId)}/alert-status`);

export const getAlertHistory = (locationId: string, page = 1, pageSize = 20) =>
  apiClient.get<AlertHistoryPageDto>(`${loc(locationId)}/alert-history?page=${page}&pageSize=${pageSize}`);

export const listUkraineRegions = (type?: string) =>
  apiClient.get<UkraineRegionDto[]>(
    `/api/v1/ukraine-regions${type ? `?type=${encodeURIComponent(type)}` : ''}`,
  );
